export const directDebitDetails: string =
  "<p><i class='small'>" +
  "By selecting the below checkbox, you acknowledge you have read and understood the " +
  "<a href='https://campaustralia.com.au/terms-conditions' target='_new' class='underline'>Terms and Conditions</a> " +
  "and <a href='https://campaustralia.com.au/direct-debit-service-agreement' target='_new' class='underline'>Direct Debit Service Agreement</a>. " +
  "You also acknowledge that you are the nominated account holder and have authorised Camp Australia to arrange for funds to be debited from your allocated account.";

export const TransactionClassAttendance = 2;

export const bankMerchantTransactionFee = 0.24;
export const ccDefaultSurcharge = 0.75;
export const ccMerchantTransactionFee = 0.14;
